import { Controller } from '@hotwired/stimulus';

const CLASS_HIDDEN = 'd-none';

export default class extends Controller {
  static targets = ['row', 'showMoreText', 'showLessText'];

  connect() {
    this.rowTargets.forEach((row) => row.classList.add(CLASS_HIDDEN));
    this.showMoreTextTarget.classList.remove(CLASS_HIDDEN);
  }

  toggle({ currentTarget }) {
    const expanded = currentTarget.getAttribute('aria-expanded') === 'true';
    currentTarget.setAttribute('aria-expanded', !expanded);

    this.rowTargets.forEach((row) =>
      row.classList.toggle(CLASS_HIDDEN, expanded)
    );
    this.showMoreTextTarget.classList.toggle(CLASS_HIDDEN, !expanded);
    this.showLessTextTarget.classList.toggle(CLASS_HIDDEN, expanded);
  }
}
